import React, { useState } from "react";
import { MdKeyboardArrowDown } from "react-icons/md";
import ScienceOutlinedIcon from "@mui/icons-material/ScienceOutlined";
import { Avatar, Collapse } from "@mui/material";
import Colors from "../../constants/Colors";
import { PersonExamType } from "../../core/http/service/PersonExam";
import { Button } from "../../pages/company/companyRegister/CompanyRegister.styled";
import {
  ExamCardContainer,
  ExamCardDateContainer,
  ExamCardInfoContainer,
  ExamCardNameContainer,
} from "../../pages/exams/Exams.style";
import { Text } from "../UI/generalLayout/Layout.styled";

export interface ExamCardProps {
  data: PersonExamType;
  onSearchEqual: (name: string) => void;
  filter?: boolean;
}

const convertDay = (day: string) => {
  if (!day) return "";
  const dayArray = day.split("-");
  return `${dayArray[2]}/${dayArray[1]}/${dayArray[0]}`;
};

const ExamCard: React.FC<ExamCardProps> = ({ data, filter, onSearchEqual }) => {
  const [openCard, setOpenCard] = useState(filter ? true : false);

  const { dataResultado, nomeExame, valor, unidade, formato } = data;

  const convertTextResult = (text: string) => {
    if (!text) return [];
    const results = text.split('*');
    return results;
  }

  const ExamResult = () => {      
    const results = convertTextResult(valor);
    return (<>
     {isNumeric ? (<Text style={{ color: "#0F172A", fontSize: "14px", fontWeight: 500 }}>{`${valor} ${unidade ?? ''}`}</Text>) : (
      <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
        {results.map((r, i) => {
          return <Text key={i} style={{ color: "#0F172A", fontSize: "14.5px", lineHeight: "20px" }}>{r}</Text>
        })}
      </div>
     )}
    </>)
  }

  const isNumeric = formato === "Numerico";

  return (
    <div style={{ margin: "6px 0" }}>
      <ExamCardContainer onClick={() => setOpenCard((value) => !value)}>
        <ExamCardNameContainer>
          <Avatar
            style={{
              height: "40px",
              width: "40px",
              minWidth: "40px",
              minHeight: "40px",
              borderRadius: "10px",
              backgroundColor: "#F0F9FF",
              color: "#0A5190",
              flexShrink: 0
            }}
          >
            <ScienceOutlinedIcon style={{ fontSize: "22px" }} />
          </Avatar>
          <Text style={{ fontSize: "14.5px", fontWeight: 600, color: "#0F172A", margin: 0 }}>
            {nomeExame}
          </Text>
        </ExamCardNameContainer>
        <ExamCardDateContainer>
          <span style={{ 
            background: "#F1F5F9", 
            color: "#475467", 
            padding: "4px 12px", 
            borderRadius: "12px", 
            fontSize: "12.5px", 
            fontWeight: 600 
          }}>
            {convertDay(dataResultado)}
          </span>
          <MdKeyboardArrowDown 
            size={24} 
            style={{ 
              color: openCard ? "#0A5190" : "#64748B",
              transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              transform: openCard ? "rotate(180deg)" : "rotate(0deg)"
            }} 
          />
        </ExamCardDateContainer>
      </ExamCardContainer>

      <Collapse in={openCard} timeout={300}>
        <ExamCardInfoContainer>
          <ExamResult />
          {!isNumeric ? (
            <Button
              onClick={() => onSearchEqual(nomeExame)}
              backgroundColor="#FFFFFF"
              color="#0A5190"
              borderColor="#0A5190"
              style={{
                borderRadius: "8px",
                padding: "8px 16px",
                fontSize: "13px",
                fontWeight: 600,
                alignSelf: "flex-start",
                cursor: "pointer",
                marginTop: "6px"
              }}
            >
              Ver exames semelhantes
            </Button>
          ) : null}
        </ExamCardInfoContainer>
      </Collapse>
    </div>
  );
};

export default ExamCard;
